import React from "react";
import RoutesApp from "./routes";
import { AuthProvider } from "./contexts/auth";
// No seu App.js ou arquivo principal
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFileLines, faBell, faChevronDown, faRightFromBracket, faXmark, faListUl, faCircleCheck, faTriangleExclamation,
  faCircleXmark, faCircleInfo, faGear,} from '@fortawesome/free-solid-svg-icons'
import { faBell as faBellRegular } from '@fortawesome/free-regular-svg-icons'
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

library.add(
  faFileLines,
  faBell,
  faChevronDown,
  faRightFromBracket,
  faBellRegular,
  faXmark,
  faListUl,
  faCircleCheck,
  faTriangleExclamation,
  faCircleXmark,
  faCircleInfo,
  faGear,
  faBellRegular,
);


const App = () => (
  <I18nextProvider i18n={i18n}>
    <AuthProvider>
      <RoutesApp />
    </AuthProvider>
  </I18nextProvider>
);

export default App;